/* -------------------------------------------------------------------------- */
/*                              INDIVIDUAL PATHS                              */
/* -------------------------------------------------------------------------- */

export const homePath = {
    url: "/",
    alt: "Noun Project home"
};

export const eduPath = "/for-edu/";

export const eduApplyPath = "/for-edu/apply/submit/";

export const teamPath = "/team/";

export const proTeamSignupPath = "/accounts/signup/team/";

export const apiGetStartedPath = "/developers/apps/";

export const contactCustomerSupportLink = "mailto:info@thenounproject.com";

export const customerSupportLink = {
    name: "Customer Support",
    href: "https://thenounproject.zendesk.com/",
    external: true
};

export const PHOTO_PATH = "/photos/";

export const photosLandingPath = "/photos/";

export const lingoMarketingPagePath = "/lingo/";

export const accountUpgradePath = "/accounts/pricing/";

export const apiMarketingPagePath = "/developers/";

export const appsAndPluginsPath = "/apps/";

export const proSignupPath = "/accounts/signup/pro/";

export const aboutPath = "/about/";

export const legalPath = "/legal/";

export const CAREERS_PATH = "/jobs/";

export const AFFILIATES_PATH = "/affiliates/";

export const FOR_MAC_PATH = "/for-mac/";

export const FOR_ADOBE_PATH = "/for-adobe/";

export const FOR_GOOGLE_PATH = "/for-google/";

export const FOR_OFFICE_PATH = "/for-office/";

export const NP_STORE_LINK = "https://store.thenounproject.com/";

export const API_LANDING_PAGE = "/api/";

export const prepaidBalancePath = ({ username }) =>
    `/${username}/settings/prepaid-balance/`;

// /upload/ banner link:
export const UPLOADS_SUBMISSION_POLICY =
    "https://medium.com/@lindsaystuart12/c4970c98b050";

export const PRICING = "/pricing/";
export const AFFILIATES_PAGE = "/affiliates/";

// Photos Related Routes
export const SEARCH = `/search/photos/`;
export const BECOME_PHOTOGRAPHER_LANDING_PAGE = "/call-to-photographers/";
// :purchaseType should be lowercase
export const PHOTO_CHECKOUT = "/checkout/photo/:purchaseType/:photoId";
export const PHOTO_DETAIL = "/photo/:photoSlugWithId/";
export const BROWSE_BY_TAG = "/browse/term/photos/:tag/";
// BROWSE_BY_SHOOT_ID :shootInfo consist of {shoot-title}-{shoot-id}
export const BROWSE_BY_SHOOT_ID = "/browse/photo-shoot/:shootInfo/";
export const BROWSE_BY_CREATOR_USERNAME = "/browse/creator/:username/photos/";
export const BROWSE_SIMILAR_BY_PHOTO_ID = "/browse/similar/photos/:photoId/";
// BROWSE_BY_CAMPAIGN :shootInfo consist of {campaign-title}-{campaign-id}
export const BROWSE_BY_CAMPAIGN = "/browse/campaign/:campaignDetail/";

export const SOCIAL_SIGNUP = "/accounts/social/signup/";
export const SOCIAL_LOGIN = "/accounts/social/login/clear_referrer/";
export const SOCIAL_LOGIN_CANCELLED = "/accounts/social/login/cancelled/";
export const SOCIAL_LOGIN_TRY_AGAIN = "/accounts/social/login/try-again/";
export const LOGIN = "/accounts/login/";
export const FORGOT_PASSWORD = "/accounts/password/reset/";
export const RESET_PASSWORD = "/accounts/password/reset/key/:resetKey/";
export const SIGNUP = "/accounts/signup/";
export const SIGNUP_TYPE = "/accounts/signup/:signupType/";
export const LOGOUT = "/accounts/logout/";

// Icons (2020) Related Routes
export const ICON_LANDING_PAGE = "/icons/";
export const ICON_DETAIL_PAGE = "/icon/:slugWithId/";
export const ICON_CHECKOUT = "/checkout/icon/:checkoutType/:iconId/";
export const ICON_CHECKOUT_ALC = ICON_CHECKOUT.replace(
    ":checkoutType",
    "payment"
);

export const BROWSE_ICONS_SIMILAR = "/browse/icons/similar/:slugWithId/";
export const BROWSE_ICONS_FEATURED = "/browse/icons/recent/";
export const BROWSE_ICONS_BY_CREATOR = "/browse/creator/:username/icons/";

export const BROWSE_ICON_COLLECTIONS_BY_CREATOR =
    "/browse/creator/:username/icon-collections/";

export const BROWSE_CONTENT = "/browse/:type/term/:term/";
export const BROWSE_ICONS_BY_TAG = BROWSE_CONTENT.replace(":type", "icons");
export const BROWSE_PHOTOS_BY_TAG = BROWSE_CONTENT.replace(":type", "photos");
export const BROWSE_ICONS_IN_COLLECTION =
    "/browse/collection-icon/:collectionSlugWithId/";

export const SEARCH_CONTENT = "/search/:searchType/";
export const SEARCH_ICONS = SEARCH_CONTENT.replace(":searchType", "icons");
export const SEARCH_ICON_COLLECTIONS = SEARCH_CONTENT.replace(
    ":searchType",
    "icon-collections"
);

export const SEARCH_ICONS_CREATOR = "/browse/creator/:username/search/";
/* -------------------------------------------------------------------------- */
/*                    Subscription LP & Checkout Flows                        */
/* -------------------------------------------------------------------------- */

// NounPro
export const NOUN_PRO_LANDING_PAGE =
    "/pricing/icon-subscription/nounpro-individual/";
export const NOUN_PRO_CHECKOUT =
    "/checkout/subscription/individual/payment/:planType/";
export const NOUN_PRO_CONFIRMATION_PAGE =
    "/checkout/subscription/individual/confirmation/";

// NounTeam
export const NOUN_PRO_TEAM_LANDING_PAGE =
    "/pricing/icon-subscription/nounpro-team/";
export const NOUN_PRO_TEAM_CHECKOUT =
    "/checkout/subscription/team/payment/:planType/:teamName/:numSeats/:teamUser";
export const NOUN_PRO_TEAM_CONFIRMATION_PAGE =
    "/checkout/subscription/team/confirmation/";
export const NOUN_PRO_TEAM_INFO_PAGE =
    "/checkout/subscription/team/name/:planType/";

// NounPro for Education
export const NOUN_PRO_EDU_LANDING_PAGE =
    "/pricing/icon-subscription/nounpro-edu/";
export const NOUN_PRO_EDU_CHECKOUT = "/checkout/subscription/edu/payment/";
export const NOUN_PRO_EDU_CONFIRMATION_PAGE =
    "/checkout/subscription/edu/confirmation/";
export const NOUN_PRO_EDU_APPLICATION =
    "/checkout/subscription/edu/apply/form/";
export const EDU_APPLICATION_CONFIRMATION =
    "/checkout/subscription/edu/apply/confirmation/:email/";

// API routes
export const iconEditorPreviewEndpoint = ({ iconId }) =>
    `/api/private/icons/${iconId}/edit/`;

export const iconEditorTokenEndpoint = "/api/private/icons/get-key/";

/* -------------------------------------------------------------------------- */
/*                                  DASHBOARD                                 */
/* -------------------------------------------------------------------------- */

/* --------------------------- DASHBOARD - PHOTOS --------------------------- */
export const CREATOR_DASHBOARD_PHOTOS_REDIRECT = `/account/:username/photo-dashboard/`;
export const CREATOR_DASHBOARD_PHOTOS = `${CREATOR_DASHBOARD_PHOTOS_REDIRECT}:pageContent/`;
export const CREATOR_DASHBOARD_PHOTOS_ROYALTIES = CREATOR_DASHBOARD_PHOTOS.replace(
    ":pageContent",
    "photo-royalties"
);
export const CREATOR_DASHBOARD_PHOTOS_PENDING = CREATOR_DASHBOARD_PHOTOS.replace(
    ":pageContent",
    "photos-pending"
);
export const CREATOR_DASHBOARD_PHOTOS_DENIED = CREATOR_DASHBOARD_PHOTOS.replace(
    ":pageContent",
    "photos-denied"
);
export const CREATOR_DASHBOARD_PHOTOS_DEFAULT = CREATOR_DASHBOARD_PHOTOS_ROYALTIES;

/* -------------------------------------------------------------------------- */
/*                               CREATOR PROFILE                              */
/* -------------------------------------------------------------------------- */
export const PUBLIC_PROFILE = "/:username/";

/* -------------------------------------------------------------------------- */
/*                                CREATOR TOOLS                               */
/* -------------------------------------------------------------------------- */

/* --------------------------- TOOLS - PHOTOS --------------------------- */
export const PHOTO_UPLOAD = "/private/creator-tools/contribute/upload-photos/";
export const PHOTO_UPLOAD_CONFIRM = `${PHOTO_UPLOAD}confirmation/`;
export const PHOTO_UPLOAD_MAX_QUEUE = `${PHOTO_UPLOAD}hld-q/`;
export const PHOTO_UPLOAD_MAX_TIME = `${PHOTO_UPLOAD}hld-time/`;
export const PHOTO_UPLOAD_BAD_ACCOUNT = `${PHOTO_UPLOAD}incomplete-acct/`;
export const PHOTO_UPLOAD_TYPE_SELECT = `${PHOTO_UPLOAD}type-select/`;
export const PHOTO_UPLOAD_INDIVIDUAL = `${PHOTO_UPLOAD}individual/`;
export const PHOTO_UPLOAD_PHOTO_SHOOT = `${PHOTO_UPLOAD}photo-shoot/`;

/* -------------------------------------------------------------------------- */
/*                                    MENUS                                   */
/* -------------------------------------------------------------------------- */

export const ICON_DASHBOARD = "/dashboard/";
export const ICON_ACTIVITY = "/:username/activity/";
export const ICON_ROYALTIES = "/:username/royalties/";
export const ICON_UPLOADS = "/upload/";
export const ICON_CREATOR_HANDBOOK =
    "https://brand.thenounproject.com/s/Rzneqx/?v=0";

export const USER_SETTINGS = "/:username/settings/basics/";
export const USER_EMAIL_SETTING = "/accounts/email/";

export const authLinks = {
    login: {
        href: LOGIN,
        text: "Log In"
    },
    signup: {
        href: SIGNUP,
        text: "Join"
    },
    logout: {
        href: LOGOUT,
        text: "Log Out"
    }
};

export const adminMenu = [
    {
        name: "Moderation",
        href: "/fort/modparty/"
    },
    {
        name: "Members",
        href: "/fort/members/"
    },
    {
        name: "Icons",
        href: "/fort/icon/"
    },
    {
        name: "Collections",
        href: "/fort/collections/"
    }
];

export const myAccountMenu = [
    {
        name: "Settings",
        href: ({ username }) => USER_SETTINGS.replace(":username", username)
    },
    {
        name: "Billing Info",
        href: ({ username }) => `/${username}/settings/billing/`
    },
    {
        name: "Invoices",
        href: ({ username }) => `/${username}/settings/invoices/`
    },
    {
        name: "Prepaid Balance",
        href: prepaidBalancePath
    }
];

export const myStuffMenu = [
    {
        name: "Profile",
        href: ({ username }) => `/${username}/`
    },
    {
        name: "Download History",
        href: ({ username }) => `/${username}/settings/icon-history/`
    },
    {
        name: "Saved Icons",
        href: ({ username }) => `/${username}/kits/`
    }
];

export const myStuffApiMenu = [
    {
        name: "Manage API Apps",
        href: "/developers/apps/"
    },
    {
        name: "API Documentation",
        href: "https://api.thenounproject.com/",
        external: true
    }
];

export const SUBMIT_ICONS = "/creators/";

export const nounProjectMenu = [
    {
        name: "About",
        href: aboutPath
    },
    {
        name: "Blog",
        href: "https://blog.thenounproject.com/",
        external: true
    },
    {
        name: "Jobs",
        href: CAREERS_PATH
    },
    {
        name: "Iconathons",
        href: "/Iconathon1/",
        external: true
    },
    {
        name: "Submit Icons",
        href: SUBMIT_ICONS
    },
    {
        name: "Submit Photos",
        href: BECOME_PHOTOGRAPHER_LANDING_PAGE
    },
    customerSupportLink,
    {
        name: "Affiliate Program",
        href: AFFILIATES_PATH
    },
    {
        name: "Legal",
        href: "/legal/"
    }
];

export const productMenu = [
    {
        name: "Home",
        href: homePath.url
    },
    {
        name: "Icons",
        href: ICON_LANDING_PAGE
    },
    {
        name: "Photos",
        href: photosLandingPath
    },
    {
        name: "Pricing",
        href: PRICING
    },
    {
        name: "Apps & Plugins",
        href: appsAndPluginsPath
    },
    {
        name: "API",
        href: API_LANDING_PAGE
    },
    {
        name: "Lingo",
        href: lingoMarketingPagePath
    }
];

export const socialMedia = [
    {
        name: "Twitter",
        href: "https://www.twitter.com/nounproject"
    },
    {
        name: "Facebook",
        href: "https://www.facebook.com/thenounproject"
    },
    {
        name: "Instagram",
        href: "https://www.instagram.com/nounproject"
    },
    // {
    //     name: "Dribbble",
    //     href: "https://www.dribbble.com/nounproject"
    // },
    {
        name: "Behance",
        href: "https://www.behance.com/noun_project"
    }
];

export const footerMenu = [
    {
        name: "About Us",
        href: "/about/",
        external: false
    },
    {
        name: "Contact Us",
        href: `${contactCustomerSupportLink}?subject=Wanted to get in contact`,
        external: true
    },
    customerSupportLink,
    {
        name: "Jobs",
        href: CAREERS_PATH
    },
    {
        name: "Legal",
        href: "/legal/",
        external: false
    }
];

/* -------------------------------------------------------------------------- */
/*                                 MODERATION                                 */
/* -------------------------------------------------------------------------- */

export const MOD_PHOTOS = "/private/mod/photos";
